import gql from 'graphql-tag'

const SALVA_CONFIGURAZIONE = gql`
  mutation salvaConfigurazione($configurazione: SalvaConfigurazioneInput!) {
    salvaConfigurazione(configurazione: $configurazione)
  }
`

export default SALVA_CONFIGURAZIONE
